import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e9b3822"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "w-5 h-5 flex items-center justify-center rounded-full bg-green-500 p-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-white" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "w-5 h-5 flex items-center justify-center rounded-full bg-red-500 p-2"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-white" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!

  return (_ctx.column.key === 'status' && _ctx.row.status)
    ? (_openBlock(), _createBlock(_component_cheap, {
        key: 0,
        class: "small"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.row.status.name), 1)
        ]),
        _: 1
      }))
    : (_ctx.column.key === 'status_lo' && _ctx.row.waitList && _ctx.row.waitList.status)
      ? (_openBlock(), _createBlock(_component_cheap, {
          key: 1,
          class: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.row.waitList.status.name), 1)
          ]),
          _: 1
        }))
      : (_ctx.column.key === 'answer')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.isAnswer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (_ctx.row.waitList.state.id === 48)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
                    : (_ctx.row.waitList.state.id === 49)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                      : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_ctx.column.key === 'type')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createTextVNode(_toDisplayString(_ctx.getType), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key] || '-'), 1)
            ], 64))
}